import React from "react";

export const MediaContext = React.createContext({
  media: {},
  setMedia: () => {},
  initial: {},
  errors: {},
  setErrors: () => {},
  thumbnailUrl: null,
  setThumbnailUrl: () => {},
  thumbnailFile: null,
  setThumbnailFile: () => {},
  orgLogoUrl: null,
  setOrgLogoUrl: () => {},
});
